import { useEffect, useState } from 'react';

const SIDEBAR_WIDTH_PX = 280;

function checkSidebarActive() {
    const { body } = document;
    return (
        body.classList.contains('sidebar-toggle-display') &&
        !body.classList.contains('sidebar-hidden')
    );
}

/**
 * Хук для отслеживания состояния сайдбара на основе классов `body`.
 *
 * Используется в легаси-разметке, где открытие/закрытие сайдбара
 * отражается через CSS-классы:
 * - `sidebar-toggle-display`
 * - `sidebar-hidden`
 *
 * Хук подписывается на изменения атрибута `class` у `document.body`
 * через `MutationObserver` и возвращает актуальный флаг открытия.
 *
 * @returns {{ isSidebarOpen: boolean; sidebarWidth: number }}
 * `isSidebarOpen` — `true`, если сайдбар открыт, иначе `false`.
 * `sidebarWidth` — ширина сайдбара в пикселях.
 */
export const useIsSidebarOpen = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(checkSidebarActive);

    useEffect(() => {
        const { body } = document;
        const observer = new MutationObserver(() => {
            setIsSidebarOpen(checkSidebarActive());
        });

        observer.observe(body, { attributes: true, attributeFilter: ['class'] });
        setIsSidebarOpen(checkSidebarActive());

        return () => observer.disconnect();
    }, []);

    return {
        isSidebarOpen,
        sidebarWidth: SIDEBAR_WIDTH_PX,
    };
};
